import Box from './box';
import './box.sass';

export default Box;
